<app-topnav [pageName]="pageName"></app-topnav>
<div class="h-30"></div>
<div class="container">
  <div class="content" role="main">
    <div class="cmha-dashboard">
        <div class="h-30"></div>
              <div class="facility-heading">User Profile</div>
      <form>
      <div class="designatedFacilityForm">
        <div class="review-form-fileds-status">
          <span class="heading">Edit Profile</span>
        </div>

       <app-edit-profile-form [updateUser]="updateUser"></app-edit-profile-form>
        <div class="h-30"></div>
        <div class="form-buttons">
            <button class="submit-form-button" (click)="onUpdate()">Submit</button>
        </div>
    </div>
    </form>
</div>
</div>
</div>
